import Datepicker from 'vuejs-datepicker'
import { cloneDeep } from 'lodash'

// Require at the component mixin is includes:
// data:
// - items
export default {
  components: { Datepicker },
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    getUsersForSelect () {
      const usersNotActive = []
      for (const i in this.items) {
        if (!this.items[i].user) {
          continue
        }
        if (!this._prodDepUsers.some(user => user.id === this.items[i].user.id)) {
          const newUserItem = this.items[i].user
          newUserItem.disabled = true
          usersNotActive.push(newUserItem)
        }
      }
      if (usersNotActive.length > 0) {
        return [...this._prodDepUsers, ...usersNotActive]
      } else {
        return this._prodDepUsers
      }
    }
  },
  mounted () {
    if (this.$store.getters.getAllUsers.length === 0) {
      this.fetchAllUsers()
    }
    this.setInitialParams()
  },
  watch: {
    'value': {
      deep: true,
      handler () {
        this.setInitialParams()
      }
    }
  },
  methods: {
    convertDataToString (value) {
      if (value) return value.toString()
    },
    setInitialParams () {
      this.items = this.value || [cloneDeep(this.defaultItem)]
      this.triggerInputEmit()
    },
    async fetchAllUsers () {
      return this.$api.users.getAllUsers()
    },
    addItem () {
      this.items.push(cloneDeep(this.defaultItem))
      this.triggerInputEmit()
    },
    removeItem (data) {
      const removedIndex = data.index
      this.items = this.items.filter((item, index) => index !== removedIndex)
      this.triggerInputEmit()
      this.$emit('dataRemoved', { removedIndex })
    },
    triggerInputEmit () {
      this.$emit('input', this.items)
    },
    dataTouched (index, attrName, attrValue) {
      this.$emit('dataTouched', { index, attrName, attrValue })
    },
    hoursTooltip (item) {
      let tooltipText = ''
      if (item.calculateHours && (item.hours_amount_from_worklogs || item.hours_amount_from_calendar)) {
        tooltipText = 'Auto fill: '
        tooltipText += item.hours_amount_from_worklogs ? item.hours_amount_from_worklogs + ' hours from worklogs ' : ''
        tooltipText += item.hours_amount_from_calendar ? item.hours_amount_from_calendar + ' hours from v&s google doc' : ''
      }
      return tooltipText
    }
  }
}
